import ReceptionStatus from "$types/ReceptionStatus";
import ReferencingStatus from "$types/ReferencingStatus";

const { MISSING, TOTAL } = ReferencingStatus;
const { DONE, TODO } = ReceptionStatus;

export const REFERENCING_STATUS_LABELS = {
  [MISSING]: "Manquant",
  // [PARTIAL]: "Partiel", // SUPPRIMER BL-924
  [TOTAL]: "Total",
};

export const RECEPTION_STATUS_LABELS = {
  [DONE]: "Traitée",
  [TODO]: "À traiter",
};
